document.addEventListener("DOMContentLoaded", () => {
    const zoomWrapper = document.querySelector('.wcl-single-service__gallery-container');
    if (!zoomWrapper) {
        return;
    }

    const zoomLinks = Array.from(
        zoomWrapper.querySelectorAll('.wcl-single-service__gallery-zoom-link')
    );

    if (!zoomLinks.length) {
        return;
    }

    const lightbox = document.createElement('div');
    lightbox.className = 'wcl-zoom-lightbox';
    lightbox.innerHTML =
        '<button type="button" class="wcl-zoom-lightbox__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="wcl-zoom-lightbox__nav wcl-zoom-lightbox__nav--prev" aria-label="Previous">&lsaquo;</button>' +
        '<img class="wcl-zoom-lightbox__image" src="" alt="">' +
        '<button type="button" class="wcl-zoom-lightbox__nav wcl-zoom-lightbox__nav--next" aria-label="Next">&rsaquo;</button>';
    document.body.appendChild(lightbox);

    const imageEl = lightbox.querySelector('.wcl-zoom-lightbox__image');
    const prevBtn = lightbox.querySelector('.wcl-zoom-lightbox__nav--prev');
    const nextBtn = lightbox.querySelector('.wcl-zoom-lightbox__nav--next');
    const closeBtn = lightbox.querySelector('.wcl-zoom-lightbox__close');

    let currentIndex = 0;

    const showAt = (index) => {
        currentIndex = (index + zoomLinks.length) % zoomLinks.length;
        const link = zoomLinks[currentIndex];
        imageEl.src = link.getAttribute('href');
        imageEl.alt = link.getAttribute('aria-label') || '';
    };

    const openLightbox = (index) => {
        showAt(index);
        lightbox.classList.add('active');
        document.body.classList.add('wcl-zoom-lightbox-open');
    };

    const closeLightbox = () => {
        lightbox.classList.remove('active');
        document.body.classList.remove('wcl-zoom-lightbox-open');
        imageEl.src = '';
    };

    zoomLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox(index);
        });
    });

    closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
    });

    if (zoomLinks.length > 1) {
        prevBtn.addEventListener('click', () => showAt(currentIndex - 1));
        nextBtn.addEventListener('click', () => showAt(currentIndex + 1));
    } else {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
    }

    document.addEventListener('keydown', (e) => {
        if (!lightbox.classList.contains('active')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft' && zoomLinks.length > 1) showAt(currentIndex - 1);
        if (e.key === 'ArrowRight' && zoomLinks.length > 1) showAt(currentIndex + 1);
    });
});
